export default __webpack_public_path__ + "static/media/DocDownload.ff822335.svg";